if (!window.Maximize.loadedScript.includes('pagination.js')) {
  window.Maximize.loadedScript.push('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        loadData(url) {
          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById('ItemsGrid');
            if (!productGrid) return;

            const newItems = Array.from(productGrid.children);
            let productsOnPage = document.getElementById("ItemsGrid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid }
            if (!productsOnPage) return;

            const firstSoldOut = productsOnPage.querySelector('[data-available="false"]');

            newItems.forEach(item => {

              const isAvailable = item.getAttribute('data-available') === 'true' || item.hasAttribute('data-promo');
              
              if (isAvailable && firstSoldOut) {
                firstSoldOut.insertAdjacentElement('beforebegin', item);
              } else {
                productsOnPage.appendChild(item);
              }
            });
            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
            this._renderButton(html);
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          })
        } ,
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
